export default __webpack_public_path__ + "static/media/image.ddi-labs.494e6fa6.png";